import i18next from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import { registerTranslations } from '@3nickels/data-modules';

// Initialize i18next and return a promise
const i18nPromise = i18next
  .use(Backend) // Lazy loads translations from /public/locales
  .use(LanguageDetector) // Detect user language
  .use(initReactI18next)
  .init({
    fallbackLng: 'en-US',
    // We only ship en-US and es bundles (see public/locales). Collapse every detected
    // language variant (en, en-GB, es-MX, de, ...) down to one of those two so nobody
    // gets routed to a partial/unmaintained bundle or silently falls back to en-US
    // when they asked for Spanish.
    supportedLngs: ['en-US', 'es'],
    debug: false,
    useCookie: false,
    detection: {
      order: ['navigator', 'querystring', 'cookie', 'localStorage', 'htmlTag', 'path', 'subdomain'],
      caches: ['localStorage', 'cookie'],
      convertDetectedLanguage: (lng) => (lng.toLowerCase().startsWith('es') ? 'es' : 'en-US'),
    },
    react: {
      useSuspense: false,
    },
    interpolation: {
      escapeValue: false,
    },
  })
  .then(() => {
    registerTranslations(i18next);
    return i18next;
  });

export { i18nPromise };
export default i18next;
